export const WEBSITE_NAME = "EYN";
export const WEBSITE_DESCRIPTION = "Everything You Need";
export const EMAIL = "luke@wilsonriplag.com";
export const NAME = "WilsonIIRIP/LUKE";
